import { memo } from 'react';
import { LaunchContainer } from '../containers';
import { SearchBar } from './search-bar';
import { BulkActionButtonGroup } from './bulk-action-button-group';
import { ProspectDto } from '@zaplify/prospects';

export const TableToolbar = memo(
    ({
        selected,
        prospectIds,
        searchTerm,
        setSearchTerm,
        removeUserContacts,
        prospectCollectionId,
    }: {
        selected: Record<string, ProspectDto>;
        prospectIds: string[];
        searchTerm: string;
        setSearchTerm: (searchTerm: string) => void;
        removeUserContacts: (ids: string[]) => Promise<void>;
        prospectCollectionId: string;
    }) => {
        return (
            <LaunchContainer>
                <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
                <BulkActionButtonGroup
                    selected={selected}
                    prospectIds={prospectIds}
                    removeUserContacts={removeUserContacts}
                    prospectCollectionId={prospectCollectionId}
                />
            </LaunchContainer>
        );
    }
);
